module.exports = __webpack_public_path__ + "img/Tendenz_fallend.3b7c171d.svg";